
import React, { useState } from 'react';
import { useAppContext } from '../AppContext';
import { getFunctions, httpsCallable } from 'firebase/functions';

const TournamentCreationPage = ({ setView, primaryNexus }) => {
    const { user } = useAppContext();
    const [tournamentName, setTournamentName] = useState('');
    const [description, setDescription] = useState('');
    const [entryFee, setEntryFee] = useState(100);
    const [isCreating, setIsCreating] = useState(false);
    const functions = getFunctions();

    const handleCreateTournament = async () => {
        if (!tournamentName || !description) {
            alert('Please fill out all fields.');
            return;
        }
        setIsCreating(true);
        const createTournamentFn = httpsCallable(functions, 'createTournament');
        try {
            await createTournamentFn({ 
                nexusId: primaryNexus,
                name: tournamentName, 
                description, 
                entryFee 
            });
            setView('hub');
        } catch (error) {
            console.error("Error creating tournament:", error);
        } finally {
            setIsCreating(false);
        }
    };

    return (
        <div className="w-full h-full bg-gradient-to-b from-slate-900/90 to-black/95 backdrop-blur-xl text-white p-8 flex flex-col items-center justify-center overflow-hidden">
            <div className="max-w-lg w-full bg-gray-800/40 backdrop-blur-md border border-white/10 p-8 rounded-2xl shadow-2xl">
                <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500 font-orbitron mb-8 text-center">Create Tournament</h1>
                
                <div className="mb-6">
                    <label htmlFor="name" className="block text-sm font-bold text-gray-400 uppercase tracking-wider mb-2">Tournament Name</label>
                    <input 
                        type="text" 
                        id="name" 
                        value={tournamentName}
                        onChange={(e) => setTournamentName(e.target.value)}
                        className="w-full bg-gray-900/60 border border-gray-600/50 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all outline-none"
                        placeholder="Enter tournament name"
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="description" className="block text-sm font-bold text-gray-400 uppercase tracking-wider mb-2">Description</label>
                    <textarea 
                        id="description" 
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        className="w-full bg-gray-900/60 border border-gray-600/50 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all outline-none h-32 resize-none"
                        placeholder="Describe your tournament rules and prizes..."
                    />
                </div>
                <div className="mb-8">
                    <label htmlFor="entryFee" className="block text-sm font-bold text-gray-400 uppercase tracking-wider mb-2">Entry Fee (Echoes)</label>
                    <input 
                        type="number" 
                        id="entryFee" 
                        value={entryFee}
                        onChange={(e) => setEntryFee(parseInt(e.target.value, 10))}
                        className="w-full bg-gray-900/60 border border-gray-600/50 rounded-lg p-3 text-white focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all outline-none"
                    />
                </div>
                <button 
                    onClick={handleCreateTournament}
                    disabled={isCreating}
                    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-bold py-4 px-6 rounded-lg shadow-lg shadow-indigo-500/30 transition-all hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed border border-white/10"
                >
                    {isCreating ? 'Creating...' : 'Create Tournament'}
                </button>
            </div>
        </div>
    );
};

export default TournamentCreationPage;
